import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "d-flex flex-column" }
const _hoisted_2 = { class: "d-flex justify-end mt-n7" }
const _hoisted_3 = { class: "d-flex" }
const _hoisted_4 = { class: "d-flex" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "text-body-1" }, "Error Log", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-light-blue-lighten-5" }, [
    /*#__PURE__*/_createElementVNode("th", {
      id: "no",
      class: "text-center text-blue-darken-2 font-weight-black"
    }, " # "),
    /*#__PURE__*/_createElementVNode("th", {
      id: "filename",
      class: "text-left text-blue-darken-2 font-weight-black"
    }, " ชื่อไฟล์ "),
    /*#__PURE__*/_createElementVNode("th", {
      id: "size",
      class: "text-center text-blue-darken-2 font-weight-black"
    }, " ขนาดไฟล์ "),
    /*#__PURE__*/_createElementVNode("th", {
      id: "date",
      class: "text-center text-blue-darken-2 font-weight-black"
    }, " เมื่อ "),
    /*#__PURE__*/_createElementVNode("th", {
      id: "action",
      class: "text-center text-blue-darken-2 font-weight-black"
    }, " คำสั่ง ")
  ])
], -1)
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = { class: "" }
const _hoisted_9 = { class: "text-center" }
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = { class: "text-center" }

import {
  defineComponent,
  onMounted,
  reactive,
  ref,
  Ref,
  watch,
} from 'vue';

import axios from 'axios';
import { VChip } from 'vuetify/components/VChip';
import NProgress from '../../utils/nprogress';

import api from '../../apis/api';
import config from '../../config';
import type {
  ConnectionResult,
  Log,
} from '../../models/api';
import type { List } from '../../models/component';
import stateLogin from '../../store/state-login';
import { state as stateSnackbar } from '../../store/state-snackbar';
import sessionStorage from '../../repository/session-storage';
import dateFormat from '../../utils/date';
import { delay } from '../../utils/util';
import cwConfirmFile from '../ConfirmFile.vue';
import CwList from '../List.vue';
import cwTextLogo from '../TextLogo.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Detail',
  props: {
  logoutCallback: {
    type: Function,
    required: true,
  },
},
  setup(__props) {

const props = __props;

if (config.useMockApi) api.mock();

defineComponent({ name: 'CwDetail' });



let connectionStatus = reactive<ConnectionResult>({ status: false });
const { loginDetail } = stateLogin;

const showTableLog: Ref<boolean> = ref(false);
const loadingRegister: Ref<boolean> = ref(false);
const loadingLog: Ref<boolean> = ref(false);

const itemsLogs = reactive<Log[]>([]);
const listSubject = reactive<(List | null)[]>([]);
const confirmFile = ref();

const connection = async () => {
  try {
    const { data } = await api.connection();
    connectionStatus = Object.assign(connectionStatus, data);
  } catch (error: any) {
    stateSnackbar.show({
      text: error?.response?.data?.errorMessage ?? 'เกิดความผิดพลาด',
      color: 'error',
    });
  }
};

const log = async () => {
  try {
    loadingLog.value = true;
    const { data } = await api.log();

    data.sort((a: Log, b: Log) => {
      const dateA = +new Date(a.modifyAt);
      const dateB = +new Date(b.modifyAt);
      if (dateA > dateB) return -1;
      if (dateA < dateB) return 1;
      return 0;
    });

    itemsLogs.splice(0);
    Object.assign(itemsLogs, data);
  } catch (error: any) {
    console.log('log error: ', error);
    stateSnackbar.show({
      text: error?.response?.data?.errorMessage ?? 'เกิดความผิดพลาด',
      color: 'error',
    });
    showTableLog.value = false;
  } finally {
    loadingLog.value = false;
  }
};

const register = async () => {
  try {
    loadingRegister.value = true;
    const { data } = await api.register();
    loginDetail.registerStatus = true;
    loginDetail.registerAt = data.registerAt;
    sessionStorage.setLoginInfo(loginDetail);
    const listSubject4 = listSubject.at(4);
    const listSubject5 = listSubject.at(5);
    if (listSubject4) {
      listSubject4.line2 = {
        text: loginDetail.registerStatus ? 'ลงทะเบียนแล้ว' : 'ยังไม่ได้ลงทะเบียน',
        props: {
          class: {
            'text-primary': loginDetail.registerStatus,
            'text-error': !loginDetail.registerStatus,
          },
        },
      };
    }

    if (listSubject5) {
      listSubject5.line2 = {
        text: dateFormat(loginDetail.registerAt).toDateTimeShort(),
      };
    }

    stateSnackbar.show({
      text: 'ลงทะเบียนสำเร็จ',
      color: 'success',
    });
  } catch (error: any) {
    stateSnackbar.show({
      text: error?.response?.data?.errorMessage ?? 'เกิดความผิดพลาด',
      color: 'error',
    });
  } finally {
    loadingRegister.value = false;
  }
};

const logout = async () => {
  NProgress.start();
  api.logout();
  sessionStorage.removeLoginInfo();
  await delay(1000);
  stateSnackbar.show({
    text: 'ออกจากระบบ',
    color: 'primary',
    // props: { timeout: 1000 },
  });
  props.logoutCallback();
  NProgress.done();
};

const deleteFile = async (file: Log) => {
  const chk = await confirmFile.value.show({
    title: 'ยืนยันการลบไฟล์',
    text: 'custom confirm-component',
    color: 'error',
    props: {
      name: file.fileName,
      date: dateFormat(file.modifyAt?.toString() ?? '').toDateTimeShort() || '-',
      size: `${(file.size / 1024).toFixed(2)} Mb`,
    },
  });
  if (chk) {
    try {
      await api.deleteLog(file.fileName);
      await log();
    } catch (error: any) {
      stateSnackbar.show({
        text: error?.response?.data?.errorMessage ?? 'เกิดความผิดพลาด',
        color: 'error',
      });
    }
  }
};

const downloadLog = async (filename: string) => {
  window.open(`/api/manage/log/${filename}?dl`, '_blank');
};

const openLog = async (filename: string) => {
  window.open(`/api/manage/log/${filename}`, '_blank');
};

watch(showTableLog, (val) => {
  if (val) {
    log();
    return;
  }
  itemsLogs.splice(0);
});

onMounted(async () => {
  await connection();

  const createLine1 = (text: string): List['line1'] => ({ text, props: { class: 'font-weight-black' } });

  const createLine2 = (text: string | number): List['line1'] => ({ text });

  const createAvartar = (icon: string): List['avatar'] => ({
    props: { class: 'bg-primary-opacity-3' },
    icon: { props: { icon, color: 'primary' } },
  });

  const list: (List | null)[] = [
    {
      line1: createLine1('รหัสหน่วยงาน'),
      line2: createLine2(loginDetail.officeID),
      avatar: createAvartar('mdi-numeric'),
    },
    {
      line1: createLine1('หน่วยงาน'),
      line2: createLine2(loginDetail.officeName),
      avatar: createAvartar('mdi-bag-checked'),
    },
    {
      line1: createLine1('ผู้ลงทะเบียน'),
      line2: createLine2(loginDetail.superuser),
      avatar: createAvartar('mdi-account'),
    },
    null,
    {
      line1: createLine1('สถานะ'),
      line2: {
        text: loginDetail.registerStatus
          ? 'ลงทะเบียนแล้ว'
          : 'ยังไม่ได้ลงทะเบียน',
        props: {
          class: {
            'text-primary': loginDetail.registerStatus,
            'text-error': !loginDetail.registerStatus,
          },
        },
      },
      avatar: createAvartar('mdi-pencil'),
    },
    {
      line1: createLine1('วันที่ลงทะเบียน'),
      line2: createLine2(dateFormat(loginDetail.registerAt ?? '').toDateTimeShort() ?? '-'),
      avatar: createAvartar('mdi-calendar-blank'),
    },
    {
      line1: createLine1('สถานะการเชื่อมต่อ'),
      line2: {
        component: VChip,
        props: {
          'prepend-icon': 'mdi-circle',
          color: connectionStatus.status ? 'primary' : 'error',
          text: connectionStatus.status ? 'Online' : 'Offline',
          size: 'small',
        },
      },
      avatar: createAvartar('mdi-connection'),
    },
    {
      line1: createLine1('ตรวจสอบเมื่อ'),
      line2: createLine2(dateFormat(connectionStatus.healthCheckedAt ?? '').toDateTimeShort() ?? '-'),
      avatar: createAvartar('mdi-check-decagram-outline'),
    },
  ];

  listSubject.push(...list);
});

return (_ctx: any,_cache: any) => {
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        justify: "end",
        "no-gutters": "",
        class: "my-6"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "4",
            offset: "4"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, {
                justify: "center",
                "no-gutters": ""
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", null, [
                      _createVNode(cwTextLogo, {
                        "sub-title": { text: `PROXY SERVER${_unref(loginDetail).proxyID ? ` #${_unref(loginDetail).proxyID}` : ''}`, fontWeight: 'normal' }
                      }, null, 8, ["sub-title"])
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { cols: "4" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_v_btn, {
                  "prepend-icon": "mdi mdi-tray-arrow-up mdi-rotate-90",
                  variant: "plain",
                  color: "primary",
                  onClick: logout
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" ออกจากระบบ ")
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { justify: "center" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "8" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listSubject, (it, id) => {
                        return (_openBlock(), _createBlock(_component_v_col, {
                          key: id,
                          cols: "6",
                          class: "my-1"
                        }, {
                          default: _withCtx(() => [
                            (it != null)
                              ? (_openBlock(), _createBlock(CwList, {
                                  key: 0,
                                  avatar: it.avatar,
                                  line1: it.line1,
                                  line2: it.line2
                                }, null, 8, ["avatar", "line1", "line2"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, {
            justify: "center",
            class: "mt-10"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_v_btn, {
                  loading: loadingRegister.value,
                  block: "",
                  rounded: "pill",
                  color: _unref(loginDetail).registerStatus ? 'registered' : 'primary',
                  size: "x-large",
                  "prepend-icon": "mdi-text-box-check",
                  onClick: register,
                  disabled: _unref(loginDetail).registerStatus
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(_unref(loginDetail).registerStatus ? "ลงทะเบียนแล้ว" : "ลงทะเบียน"), 1)
                  ]),
                  _: 1
                }, 8, ["loading", "color", "disabled"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, {
            justify: "center",
            class: "mt-10"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                (_unref(loginDetail).registerStatus)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      loading: loadingLog.value,
                      block: "",
                      rounded: "pill",
                      color: "primary",
                      size: "x-large",
                      variant: "outlined",
                      "prepend-icon": showTableLog.value ? 'mdi-eye-off' : 'mdi-eye',
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (showTableLog.value = !showTableLog.value))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", null, [
                          _createTextVNode(_toDisplayString(showTableLog.value ? "ซ่อน" : "แสดง") + " ", 1),
                          _hoisted_5
                        ])
                      ]),
                      _: 1
                    }, 8, ["loading", "prepend-icon"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_expand_transition, null, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_component_v_row, {
            justify: "center",
            class: "mt-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "8" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_table, null, {
                    default: _withCtx(() => [
                      _hoisted_6,
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemsLogs, (item, ind) => {
                          return (_openBlock(), _createElementBlock("tr", { key: ind }, [
                            _createElementVNode("td", _hoisted_7, _toDisplayString(ind + 1), 1),
                            _createElementVNode("td", _hoisted_8, _toDisplayString(item.fileName), 1),
                            _createElementVNode("td", _hoisted_9, _toDisplayString((item.size / 1000).toFixed(2)) + " kB ", 1),
                            _createElementVNode("td", _hoisted_10, _toDisplayString(_unref(dateFormat)(item.modifyAt?.toString() ?? '').toDateTimeShort() || '-'), 1),
                            _createElementVNode("td", _hoisted_11, [
                              _createVNode(_component_v_btn, {
                                size: "small",
                                variant: "text",
                                icon: "mdi-text-box-outline",
                                color: "info",
                                onClick: ($event: any) => (openLog(item.fileName))
                              }, null, 8, ["onClick"]),
                              _createVNode(_component_v_btn, {
                                size: "small",
                                variant: "text",
                                icon: "mdi-tray-arrow-down",
                                color: "info",
                                onClick: ($event: any) => (downloadLog(item.fileName))
                              }, null, 8, ["onClick"]),
                              _createVNode(_component_v_btn, {
                                size: "small",
                                variant: "text",
                                icon: "mdi-trash-can-outline",
                                color: item.canDelete ? 'error' : 'grey',
                                disabled: !item.canDelete,
                                onClick: () => item.canDelete ? deleteFile(item) : null
                              }, null, 8, ["color", "disabled", "onClick"])
                            ])
                          ]))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 512), [
            [_vShow, showTableLog.value && !!itemsLogs.length]
          ])
        ]),
        _: 1
      }),
      _createVNode(cwConfirmFile, {
        ref_key: "confirmFile",
        ref: confirmFile
      }, null, 512)
    ]),
    _: 1
  }))
}
}

})